import { render } from "./JumBe.vue?vue&type=template&id=7436a5c9&scoped=true"
import script from "./JumBe.vue?vue&type=script&lang=js"
export * from "./JumBe.vue?vue&type=script&lang=js"

import "./JumBe.vue?vue&type=style&index=0&id=7436a5c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7436a5c9"]])

export default __exports__